module.exports = __webpack_public_path__ + "assets/mstile-70x70.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/icons/mstile-70x70.png
// module id = 938
// module chunks = 17